import React, { useEffect, useRef } from "react";

export const RoleSectionComponent = ({
  organizationRoleId = null,
  organizationRoles = [],
  isCalledBy = "manage",
  toggleModal,
  setSelectedRoleState,
}) => {
  const divRef = useRef(null);

  /**
   * Select the role
   * @param {*} id
   */
  const handleButtonClick = (id) => {
    setSelectedRoleState(id);
  };

  /**
   * Listener to close the modal if the user clicks outside the div
   */
  useEffect(() => {
    // Function to handle clicks anywhere on the document
    function handleClickOutside(event) {
      if (divRef.current && !divRef.current.contains(event.target)) {
        toggleModal();
      }
    }

    // Add the click listener to the document
    document.addEventListener("click", handleClickOutside);

    return () => {
      // Remove the click listener when the component unmounts
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <div
      ref={divRef}
      className={
        isCalledBy === "manage"
          ? "rol-section-manage-content"
          : "rol-section-invite-content"
      }
    >
      {organizationRoles.map((item, idx) => {
        const { _id, role, description } = item;

        return (
          <div
            key={_id}
            onClick={() => {
              toggleModal();
              handleButtonClick(_id);
            }}
          >
            <span
              className="subtitle-convert-organization"
              style={{
                opacity: 1,
                color: organizationRoleId === _id ? "#5BC500" : "#ffffff",
              }}
            >
              {role}
            </span>
            {/* this should be removed, and also the description constant in map */}
            <span className="permission-description-manage">{description}</span>
          </div>
        );
      })}
    </div>
  );
};
